import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ProjectCreationForm from '../../components/postCreationForm/ProjectCreationForm';
import TabList from '../../components/postCreationForm/tablist/TabList';
import * as ROUTES from '../../constants/routes';
import { ReactComponent as BackArrow } from './backArrow.svg';

import './style.css';

const PostCreation = () => {
    const [page, setPage] = useState(0);
    const navigate = useNavigate();

    const handleBackButtonClick = () => {
        navigate(ROUTES.POSTS);
    };

    return (
        <div className="postCreationWrap">
            <div className="postCreation__header">
                <button className="backToPosts" onClick={handleBackButtonClick}>
                    <BackArrow />
                    <span>Post an opportunity</span>
                </button>
                <TabList page={page} />
            </div>
            <ProjectCreationForm page={page} setPage={setPage} />
        </div>
    );
};

export default React.memo(PostCreation);
